var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('vue-scroll',{ref:"bodyScroll",attrs:{"ops":_vm.ops},on:{"handle-scroll":_vm.handleScroll}},[_c('app-header'),_vm._v(" "),_c('router-view',{on:{"requestView02":_vm.requestView}}),_vm._v(" "),_c('app-footer',{on:{"goToTop":_vm.btnTop}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16964631","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 